import { render, staticRenderFns } from "./CercaMateriale.vue?vue&type=template&id=aac60484"
import script from "./CercaMateriale.vue?vue&type=script&lang=js"
export * from "./CercaMateriale.vue?vue&type=script&lang=js"
import style0 from "./CercaMateriale.vue?vue&type=style&index=0&id=aac60484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports